import { Component, ViewChild } from '@angular/core';
import { NavController, NavParams, ToastController, ViewController, AlertController, LoadingController, ActionSheetController } from 'ionic-angular';
import { Validators, FormBuilder, FormGroup, AbstractControl } from '@angular/forms';
import { DomSanitizer } from '@angular/platform-browser';

import { Storage } from '@ionic/storage';

import { BusinessOfferManagerHandler } from '../../providers/business-offer-handler';

import { BusinessOfferListPage } from '../business-offer-list/business-offer-list';

import { Camera, CameraOptions } from '@ionic-native/camera';

import { Globals } from '../../providers/globals';

export function ValidMultiUse(control: AbstractControl) {
	try{
		const group = control.parent;

		var hasMultiUse = group.controls['HasMultiUseQuantity'].value;
		var multiUseCount = control.value;

		if (hasMultiUse==true && (multiUseCount == 0 || multiUseCount==null) ) {
			return { invalidFormat: true };
		}else{	
			return null;
		}
	}catch(e){
		return { invalidFormat: true };
	}
}

@Component({
  selector: 'page-business-offer-manager',
  templateUrl: 'business-offer-manager.html',
})
export class BusinessOfferManagerPage {
	@ViewChild('fileInput') fileInput;

	offer: any;
	offerMedia: any = [];
	hasMedia: boolean;
	private form : FormGroup;
	public imageSrc: string;
	loader: any;
	filePath: any;
	isLoading: boolean = false;
	saveIsLoading: boolean = false;
	deleteIsLoading: boolean = false;
	imageChanging: boolean = false;
	isActivating: boolean = false;
	hasExpirationDate: boolean = false;
	currentYear : any = (new Date()).getFullYear();
	futureYear: any = (this.currentYear + 10);
	activateOfferCancelled: boolean = false;

	hasMultiUses: boolean = false;

  	constructor(  		
  		private toastCtrl: ToastController,
			public navCtrl: NavController, 
			public viewCtrl: ViewController,
			public navParams: NavParams,
			private formBuilder: FormBuilder,
			public offerManagerHandler: BusinessOfferManagerHandler,
			public storage: Storage,
			private camera: Camera,
			public loadingCtrl: LoadingController,
			public alertCtrl: AlertController,
			public globals: Globals,
			public actionSheetCtrl: ActionSheetController,
			public _DomSanitizer: DomSanitizer
		) {

  		this.offer = navParams.get('offer');
		
	    this.form = this.formBuilder.group({
	    	"Id": [''],

	    	
	    	"ProductCategoryId":  ['', Validators.required],
		  	"OfferName":  ['', Validators.required],
		  	"OfferDescription":  [''],
		  	"OfferValue":  [''],
		  	"OfferDiscount":  [''],
		    "AvailableFrom": ['', Validators.required],
		    "AvailableTo": ['', Validators.required],
		    "OfferPrice": ['', Validators.required],
		    "OfferTerms": [''],
		    "HasExpirationDate": [false],
		    "ExpirationDate": ['', Validators.required],
		    "AvailableQuantity": [''],
		    "MaxQuantity": ['1', Validators.required],

		    "HasMultiUseQuantity": [false],
		    "MultiUseQuantity": [null, 
									Validators.compose([
										ValidMultiUse
									])
								],

		    "SoldQuantity": [''],
		    "IsActive": [false],
	   	});   
  	}

  	ionViewWillEnter() {
		if(this.offer.Id){
	   		this.loadOffer(this.offer.Id);
	    } else {
	    	this.offerMedia = []
	    }
	}

	loadOffer(id){
		this.isLoading = true;

		this.offerManagerHandler.getOffer(id, (result)=>{
		  	
		  	if(result.offer.Id != ''){
		  		this.offer = result.offer;

		  		this.form.patchValue(
					this.offer
		    	)

		    	let expirationDate = result.offer.ExpirationDate ? (new Date(result.offer.ExpirationDate)).toLocaleDateString() : '';

		  		this.form.patchValue({
		  			"ExpirationDate": expirationDate,
		  			"HasExpirationDate": (expirationDate != ''),
		  			"HasMultiUseQuantity": (result.offer.MultiUseQuantity>0) ? true : false
		  		})

		    	this.offerMedia = result.offerMediaList;

		    	this.hasMedia = this.offerMedia.length > 0;		    	
		  	}

		  	this.isLoading = false;
		})
	}

	deleteOffer(){
		this.deleteIsLoading = true;
		
		this.offerManagerHandler.deleteOffer(this.offer.Id, (result)=>{
			this.deleteIsLoading = true;

			if(result.Success)
				this.navCtrl.pop();
			else{
				let alert = this.alertCtrl.create({
	              title: 'Error',
	              subTitle: result.Message,
	              buttons: ['Ok']
	            });

	            alert.present();
			}
		});			
	}

	presentDeleteConfirmation() {
	  let alert = this.alertCtrl.create({
	    title: 'Confirm deletion',
	    message: 'Do you want to delete this offer?',
	    buttons: [
	      {
	        text: 'Delete',
	        handler: () => {
	          console.log('Delete clicked');
	          this.deleteOffer()
	        }
	      },
	      {
	        text: 'Cancel',
	        role: 'cancel',
	        handler: () => {
	          console.log('Cancel clicked');
	        }
	      }
	    ]
	  });
	  alert.present();
	}

	respondTryActivate($toggle, resp){
		var msg = ($toggle.value) ? "Offer activated." : "Offer deactivated.";

		if(resp.Message!="" && resp.Message!=null){
			msg = resp.Message;
			this.activateOfferCancelled = true;
			$toggle.value = false;			

	  		let alert = this.alertCtrl.create({
              title: 'Error',
              subTitle: msg,
              buttons: ['Ok']
            });

            alert.present();	            			
		}else{
			let toast = this.toastCtrl.create({
				message: msg,
				duration: 3000,
				position: 'bottom'
			});

			toast.present();					
		}			
	}

	tryActivation($toggle) {
		if(this.activateOfferCancelled){
			this.activateOfferCancelled = false;
			return;
		}

		//Verify if user can activate offer
		var isActivated = $toggle.value;
		
		var cb = ()=>{
			this.isActivating = true;

			this.offerManagerHandler.activateOffer({
				id: this.offer.Id,
				activate: isActivated,
				cb: (resp)=>{	
					this.isActivating = false;
					
					this.respondTryActivate($toggle, resp);
				}
			})			
		}

		var msg = "";

		if($toggle.value){
			msg = "This will make the offer available to the world, are you sure?";
		}else{
			msg = "This will hide the offer from the world, are you sure?";
		}

		if($toggle.value) {
		  let alert = this.alertCtrl.create({
		    title: 'Offer Visibility',
		    message: msg,
		    buttons: [
		      {
		        text: 'Cancel',
		        role: 'cancel',
		        handler: () => {
		        	this.activateOfferCancelled = true;
					$toggle.value = ($toggle.value) ? false : true;
		        }
		      },
		      {
		        text: 'Confirm',
		        handler: () => {		        	
		          	cb();
		        }
		      }
		    ]
		  });
		  alert.present();
		}else{
			cb();
		}
	}

	toggleMultiUse($toggle){
		var multiUseQuantity = this.form.controls['MultiUseQuantity'].value;

		if($toggle.value==false){
			multiUseQuantity = null;
		}

  		this.form.patchValue({
  			"HasMultiUseQuantity": $toggle.value==true,
  			"MultiUseQuantity": multiUseQuantity
  		});

  		this.form.controls['MultiUseQuantity'].updateValueAndValidity();
	}

	onSubmit(){
		this.saveIsLoading = true;

		if(this.form.value.Id != ''){

			console.log("entered update");

			this.offerManagerHandler.updateOffer(this.form.value.Id, this.form.value, (result)=>{
				if(result.Success){
					let toast = this.toastCtrl.create({
						message: 'Offer has been updated',
						duration: 3000,
						position: 'bottom'
					});

					toast.present();						
				} else {
					let alert = this.alertCtrl.create({
				    	title: 'Error',
				    	subTitle: result.Message,
				    	buttons: ['Ok']
				  	});
				  	
				  	alert.present();
				}

				this.saveIsLoading = false;
			})

		} else {
			console.log("entered create");

			this.offerManagerHandler.createOffer(this.form.value, (result)=>{
				if(result.Success){
					this.loadOffer(result.Data.Id);
				} else {
					let alert = this.alertCtrl.create({
				    	title: 'Error',
				    	subTitle: result.Message,
				    	buttons: ['Ok']
				  	});
				  	
				  	alert.present();
				}
			  				  	
				this.saveIsLoading = false;
			})
		}		  	
	}

	getPicture() {
	    if (Camera['installed']()) {

	      this.presentActionSheet();
	    
	    } else {
	      
	      this.fileInput.nativeElement.click();
	    
	    }
	}

	presentActionSheet() {
	   let actionSheet = this.actionSheetCtrl.create({
	     title: 'Choose the source for an image',
	     buttons: [
	       {
	         text: 'Camera',
	         handler: () => {
	           console.log('Archive clicked');

	           this.getImage(true)
	         }
	       },
	       {
	         text: 'Image Gallery',
	         handler: () => {
	           console.log('Archive clicked');

	           this.getImage(false)
	         }
	       },
	       {
	         text: 'Cancel',
	         role: 'cancel',
	         handler: () => {
	           console.log('Cancel clicked');
	         }
	       }
	     ]
	   });

	   actionSheet.present();
	}

	private getImage (fromCamera): void {
		var sourceType = fromCamera ? this.camera.PictureSourceType.CAMERA : this.camera.PictureSourceType.PHOTOLIBRARY

		const options: CameraOptions = {
	  	  	sourceType: sourceType,
		  	destinationType: this.camera.DestinationType.DATA_URL,  
		    mediaType: this.camera.MediaType.PICTURE,    
		    allowEdit: true,
		    quality: 30,
		    targetWidth: 500,
		    targetHeight: 500,
		    encodingType: this.camera.EncodingType.PNG,      
		    correctOrientation: true
		}

		this.imageChanging = true;

		this.camera.getPicture(options).then((dataUrl) => {
			console.log(dataUrl);
			
			this.offerManagerHandler
			.uploadOfferImage({
				id: this.offer.Id,
				imageString: 'data:image/png;base64,' + dataUrl,
				cb: (data)=>{ 
					this.imageChanging = false;

					this.offerMedia.push(data.Data);

					this.hasMedia = this.offerMedia.length > 0;
				}
			})

		}, (err) => {
		 // Handle error
		 alert('Unable to take photo');
		 this.imageChanging = false;
		});
	}

	processWebImage(event) {
		var file = event.target.files[0];
		var extension = file.name.substr((file.name.lastIndexOf('.') + 1));

		if(extension == 'png') {
		    let reader = new FileReader();

		    reader.onload = (readerEvent) => {

			    let imageData = (readerEvent.target as any).result;

			    this.imageChanging = true;

				this.offerManagerHandler
				.uploadOfferImage({
					id: this.offer.Id,
					imageString: imageData,
					cb: (data)=>{ 
						this.imageChanging = false;

						this.offerMedia.push(data.Data);

						this.hasMedia = this.offerMedia.length > 0;
					}
				})
		    }; 

		    reader.readAsDataURL(event.target.files[0]);
		} else {

			let alert = this.alertCtrl.create({
				    	title: 'Error',
				    	subTitle: "Only images with a png extension are allowed.",
				    	buttons: ['Ok']
				  	});
				  	
		  	alert.present();

		}
	}

	confirmRemoveMedia(mediaId) {
	    const confirm = this.alertCtrl.create({
	      title: 'Alert',
	      message: 'Do you want to remove this image?',
	      buttons: [
	        {
	          text: 'No',
	          handler: () => {
	          }
	        },
	        {
	          text: 'Yes',
	          handler: () => {
	            console.log('Agree clicked');

	            this.removeMedia(mediaId)
	          }
	        }
	      ]
	    });
	    confirm.present();
	}

	removeMedia(mediaId){
		var loader = this.loadingCtrl.create({
			content: "Deleting...",
			showBackdrop: true
		});

		loader.present(); 

		this.deleteIsLoading = true;
		
		this.offerManagerHandler.deleteImage(mediaId, (result)=>{
			this.deleteIsLoading = false;
			loader.dismiss();  

			if(result.Success) {
				console.log(this.offerMedia)
				this.offerMedia = this.offerMedia.filter(function(item) {
					console.log("Filter")
					console.log(mediaId)

				    return item.Id != mediaId;
				});
				console.log("After delete")
				console.log(this.offerMedia)

				this.hasMedia = this.offerMedia.length > 0;

				let alert = this.alertCtrl.create({
	              title: 'Sucess',
	              subTitle: "Image has been removed",
	              buttons: ['Ok']
	            });

	            alert.present();
			} else{
				let alert = this.alertCtrl.create({
	              title: 'Error',
	              subTitle: result.Message,
	              buttons: ['Ok']
	            });

	            alert.present();
			}
		});
	}
}


// WEBPACK FOOTER //
// ./src/pages/business-offer-manager/business-offer-manager.ts